var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToolButton',{attrs:{"Editor":_vm.Editor,"KnownIcon":"ListOrdered"},on:{"ToolClick":function($event){_vm.Editor.chain().focus().toggleOrderedList().run()}}},[_vm._v("\n:class=\"{ 'toggled': Editor.isActive('orderedList') }\"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }